import { render, staticRenderFns } from "./LeftGridEventList.vue?vue&type=template&id=0b7d909c"
import script from "./LeftGridEventList.vue?vue&type=script&lang=js"
export * from "./LeftGridEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports